import { config } from "../config/config";
import { getAuthToken } from "./tokenService.service";

export const costofsalesService = {
  getCostOfSales: async (branch_id: string) => {
    const token = getAuthToken();

    const response = await fetch(`${config.baseURL}/costofsales/summary`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ branch_id }),
    });

    if (!response.ok) {
      throw new Error("Failed to fetch cost of sales");
    }

    const json = await response.json();
    return json.data;
  },
};
